import { useQuery, UseQueryOptions } from 'react-query';
import { getFbPixel } from '~/api/routes/auth/user';

import { useAccountQuery } from './useAccountQuery';

type UseFbPixelQueryOptions<TError, TData> = Omit<UseQueryOptions<string, TError, TData>, 'enabled'>;

export function useFbPixelQuery<TError = unknown, TData = string>(options?: UseFbPixelQueryOptions<TError, TData> = {}) {
  const [accountId] = useAccountQuery();

  return useQuery(['facebook-pixel', accountId], () => getFbPixel(accountId as string), {
    enabled: !!accountId,
    ...options,
  });
}
